module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "seller",
    staticClass: "seller"
  }, [_c('div', {
    staticClass: "seller-content"
  }, [_c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "overview-top"
  }, [_c('h4', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "rating-wrap"
  }, [_c('stars', {
    attrs: {
      "size": "36",
      "score": _vm.seller.score
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "rating-count"
  }, [_vm._v("(" + _vm._s(_vm.seller.ratingCount) + ")")]), _vm._v(" "), _c('span', {
    staticClass: "sell-count"
  }, [_vm._v("用售" + _vm._s(_vm.seller.ratingCount) + "单")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "overview-bottom"
  }, [_c('div', {
    staticClass: "item item-left"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("起送价")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.minPrice)), _c('i', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "item item-center"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("商家配送")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.deliveryPrice)), _c('i', [_vm._v("元")])])]), _vm._v(" "), _c('div', {
    staticClass: "item item-right"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("平均配送时间")]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.seller.deliveryTime)), _c('i', [_vm._v("分钟")])])])]), _vm._v(" "), _c('div', {
    staticClass: "collect",
    class: {
      active: _vm.isCollect
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleCollect($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-favorite"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.collectText))])])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("公告与活动")]), _vm._v(" "), _c('p', {
    staticClass: "bulletin"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))]), _vm._v(" "), _c('ul', {
    staticClass: "supports"
  }, _vm._l((_vm.seller.supports), function(item) {
    return _c('li', {
      staticClass: "support"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.classMap[item.type]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.description))])])
  }))]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("商家实景")]), _vm._v(" "), _c('div', {
    ref: "pic",
    staticClass: "image-wrap"
  }, [_c('ul', {
    staticClass: "image-list"
  }, _vm._l((_vm.seller.pics), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_c('img', {
      staticClass: "item-img",
      attrs: {
        "src": item
      }
    })])
  }))])]), _vm._v(" "), _c('split'), _vm._v(" "), _c('div', {
    staticClass: "infos"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("商家信息")]), _vm._v(" "), _c('ul', {
    staticClass: "info-list"
  }, _vm._l((_vm.seller.infos), function(item) {
    return _c('li', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item))])
  }))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43c0f5a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/seller/seller.vue
// module id = 73
// module chunks = 0